'use client';

import {ChildrenDecorator} from '@components/@shared';
import classNames from 'classnames';
import {FC, PropsWithChildren, useEffect, useState} from 'react';
import styles from './InteractivityBlocker.module.css';

const InteractivityBlocker: FC<PropsWithChildren> = ({children}) => {
    const [interactionBlocked, setInteractionBlocked] = useState(true);

    useEffect(() => {
        const unblockInteraction = () => {
            setInteractionBlocked(false);
        };

        if (document.readyState === 'complete') {
            unblockInteraction();
            return;
        }

        window.addEventListener('load', unblockInteraction);

        return () => {
            window.removeEventListener('load', unblockInteraction);
        };
    }, []);

    return (
        <ChildrenDecorator
            data-tid={interactionBlocked ? 'interactivity-blocker' : undefined}
            className={classNames({[styles.blocker]: interactionBlocked})}
        >
            {children}
        </ChildrenDecorator>
    );
};

export default InteractivityBlocker;
